export default {
  dbl_sql_view_title: 'SQL View',
  dbl_sql_view_enter_analysis: 'Enter Analysis',
  dbl_sql_view_enter_analysis_tooltip: 'Please select a data table first.',
  dbl_sql_view_search: 'Search by name, description, field or chart name',
  dbl_sql_view_add_new_sql_view: 'Add New SQL View',
  dbl_sql_view_category: 'Category',

  dbl_sql_view_name: 'Table',
  dbl_sql_view_description: 'Description',
  dbl_sql_view_creator: 'Creator',
  dbl_sql_view_creator_time: 'Create Time',
  dbl_sql_view_usage_count: 'Usage Count',
  dbl_sql_view_chart_name: 'Chart Name',
  dbl_sql_view_chart_names: 'Relevant Chart',
  dbl_sql_view_label: 'Label',
  dbl_sql_view_cycle: 'Update Cycle',
  dbl_sql_view_operation: 'Actions',

  dbl_sql_view_analysis: 'Analysis',
  dbl_sql_view_details: 'Details',
  dbl_sql_view_edit: 'Edit',
  dbl_sql_view_delete: 'Delete',
  dbl_sql_view_permission: 'Permission',
  dbl_sql_view_more: 'More',

  dbl_sql_view_total: "Total {total} Items",
  dbl_sql_view_tooltip: "The system table information does not match the database table information. Please contact the data classmate and v_blljli to check.",
  
  dbl_sql_view_warning_to_delete_title: "Unable to delete",
  dbl_sql_view_warning_to_delete_message: "The dataset {name} is linked to one or more charts. Deleting the dataset will break the associated chart(s). Please unlink them first.",
  dbl_sql_view_sure_to_delete_title: "Delete SQL View",
  dbl_sql_view_sure_to_delete_message: "Are you sure you want to continue? This action cannot be undone.",
  dbl_sql_view_i_know: "Got it",
  dbl_sql_view_delete_success: "Delete successful.",
  dbl_sql_view_delete_fail: "Delete failed, error code {code}.",

  dbl_sql_view_add_sql: "New SQL View",
  dbl_sql_view_edit_sql: "Edit SQL View",
};